import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import { getCategoryName, getCategoryId } from "template-store/services/solution-categories-service";
import { getSolutionCategoryPageLink } from "template-store/services/solution-links-service";
import { MENU_CATEGORY_CLICKED, SOLUTION_STORE_SEARCH_COMPLETED } from "/constants/bigbrain-event-types";
import { trackEvent } from "services/bigbrain-service";
import { HOME_ID } from "template-store/constants/categories";
import dynamic from "next/dynamic";
import SearchIcon from "monday-ui-react-core/dist/icons/Search";
import CloseSmall from "monday-ui-react-core/dist/icons/CloseSmall";
import Favorite from "monday-ui-react-core/dist/icons/Favorite";
import CustomSelect from "./costume-select/custom-select";
import { StyledMobileTemplatesNavigation } from "./mobile-navigation-component.scss";
const Search = dynamic(()=>import("monday-ui-react-core/dist/Search"), {
    ssr: false
});
const MobileTemplatesNavigation = (props)=>{
    const { allCategories, translate, selectedCategoryId, onSearchChange, searchTerm, showSearch, focusOnSearch } = props;
    const categoryOptions = useMemo(()=>{
        const categories = allCategories.map((categoryData)=>{
            const categoryId = getCategoryId(categoryData);
            const categoryName = getCategoryName(categoryData);
            return {
                value: categoryId,
                label: categoryName
            };
        });
        categories.unshift({
            value: HOME_ID,
            label: translate("templateCenter.template.featured"),
            iconComponent: Favorite
        });
        return categories;
    }, [
        allCategories,
        translate
    ]);
    const selectedOption = useMemo(()=>{
        return categoryOptions.find((option)=>option.value === selectedCategoryId);
    }, [
        categoryOptions,
        selectedCategoryId
    ]);
    const chooseCategory = useCallback((option)=>{
        if (!(option === null || option === void 0 ? void 0 : option.value) || (option === null || option === void 0 ? void 0 : option.value) === selectedCategoryId) return;
        const link = getSolutionCategoryPageLink(option.value);
        trackEvent(MENU_CATEGORY_CLICKED, {
            kind: option.value
        });
        window.location = link;
    }, [
        selectedCategoryId
    ]);
    const onSearchBlur = useCallback((e)=>{
        var _e_target;
        trackEvent(SOLUTION_STORE_SEARCH_COMPLETED, {
            kind: e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value
        });
    }, []);
    return /*#__PURE__*/ _jsxs(StyledMobileTemplatesNavigation, {
        className: "mobile-navigation-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mobile-category-wrapper",
                children: /*#__PURE__*/ _jsx(CustomSelect, {
                    className: "category-dropdown",
                    value: selectedOption,
                    classNamePrefix: "select",
                    isClearable: false,
                    isSearchable: false,
                    name: "category",
                    options: categoryOptions,
                    onChange: chooseCategory
                })
            }),
            showSearch && /*#__PURE__*/ _jsx("div", {
                className: "mobile-search-wrapper",
                children: /*#__PURE__*/ _jsx(Search, {
                    placeholder: translate("templateCenter.template.search"),
                    onChange: onSearchChange,
                    value: searchTerm,
                    iconName: SearchIcon,
                    secondaryIconName: CloseSmall,
                    onBlur: onSearchBlur,
                    autoFocus: focusOnSearch
                })
            })
        ]
    });
};
MobileTemplatesNavigation.defaultProps = {
    showSearch: false
};
export default withGenericConfig(MobileTemplatesNavigation);
